import { COLOR } from "../../common/Color"
import { Rectangle, Shape } from "../generic-sprites/Shape"
import { colorNum } from "./ColorUtils"
import { PhaserText } from "./PhaserText"
import { Scale } from "./Scale"

// Inspired by: https://phaser.io/examples/v2/loader/load-events#gv

export class ProgressBar {
    private readonly game: Phaser.Game
    private text: Phaser.Text
    private totalPercent: Phaser.Text
    private bar: Phaser.Graphics
    private x = Scale.x(0.2)
    private yBar = Scale.y(0.8)
    private barWidth = Scale.availableWidth() / 2
    private readonly group: Phaser.Group

    private constructor(game: Phaser.Game) {
        this.game = game
        this.group = this.game.add.group()
        this.game.load.onLoadStart.add(this.loadStart, this)
        this.game.load.onFileComplete.add(this.fileComplete, this)
        this.game.load.onLoadComplete.add(this.loadComplete, this)
    }

    static start = (game: Phaser.Game) => new ProgressBar(game)

    private loadStart = () => {
        this.text = PhaserText.create(this.game, "Loading ...", {
            x: this.x,
            y: Scale.y(0.7),
            color: COLOR.white,
            group: this.group
        })
        this.totalPercent = PhaserText.create(this.game, "100%", {
            x: this.x + this.barWidth + Scale.x(0.02),
            y: this.yBar,
            color: COLOR.white,
            group: this.group
        })

        const bar = new Rectangle(this.game, this.x, this.yBar, this.barWidth, Scale.y(0.05), {
            fillColor: 0xFFFFFF,
            group: this.group
        })
        this.bar = bar.graphics

        Shape.makeShapeAround(this.game, bar.invisibleSprite, 10, {
            lineColor: colorNum.white,
            group: this.group
        })

    }

    // tslint:disable-next-line:typedef
    private fileComplete = (progress) => {
        // This is here as a remnant of what is possible
        this.text.setText(`Loading: ${progress}%`)
        const percent = progress / 100
        this.bar.width = this.barWidth * percent
    }

    private loadComplete = () => {
        this.text.setText("Loading Complete")
        this.group.destroy(true)
    }

}